export enum State {
  VALID_URL = 1,
  INVALID,
  LOGGED,
  JOINED
}